import { useCaseGetMostRecentClosedCases } from 'api/case/case';
import { CaseModel } from 'api/model';
import Table from 'components/Table';
import { ColumnSetting } from 'components/Table/utils';
import useTranslations from 'contexts/basicData/useTranslations';
import { ColumnRenderProps } from 'pages/GlobalSearch/BulkApproveAssignmentsList/useColumnSettings';
import React, { useMemo } from 'react';

type MostRecentClosedCasesProps = {
  onSelect: (caseId: number) => void;
};

const MostRecentClosedCases: React.FC<MostRecentClosedCasesProps> = ({
  onSelect,
}) => {
  const { caseTypes } = useTranslations();

  const getMostRecentClosedCasesCall = useCaseGetMostRecentClosedCases({
    count: 10,
  });

  const columnSettings = useMemo(
    (): ColumnSetting<CaseModel, ColumnRenderProps>[] => [
      {
        head: 'ID',
        render: (model) => model.caseID,
        width: 100,
      },
      {
        head: 'Regnr',
        render: (model) => model.registrationNumber,
        width: 150,
      },
      {
        head: 'Typ',
        render: (model) => caseTypes[model.caseTypeID] ?? '',
        width: 150,
      },
      {
        head: 'Antal uppdrag',
        render: (model) => model.assignmentList.length,
        width: 150,
      },
    ],
    [caseTypes]
  );
  return (
    <Table
      columnSettings={columnSettings}
      rows={getMostRecentClosedCasesCall.data ?? []}
      onRowClick={(row) => onSelect(row.caseID)}
    />
  );
};

export default MostRecentClosedCases;
